/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateControlResultCommentRequestDto,
  EditControlResultCommentRequestDto,
  GenerateCommentAttachmentUploadUrlRequestDto,
  GenerateCommentAttachmentUploadUrlResponseDto,
  GetControlResultAttachmentListResponseDto,
  GetControlResultAttachmentUrlResponseDto,
  GetControlResultCommentListResponseDto,
  GetControlResultCommentsParams
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get control result comments list
 */
export const getControlResultComments = (
    controlId: string,
    controlResultId: string,
    params: GetControlResultCommentsParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultCommentListResponseDto>(
      {url: `/controls/${controlId}/results/${controlResultId}/comments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetControlResultCommentsQueryKey = (controlId?: string,
    controlResultId?: string,
    params?: GetControlResultCommentsParams,) => {
    return [`/controls/${controlId}/results/${controlResultId}/comments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetControlResultCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getControlResultComments>>, TError = unknown>(controlId: string,
    controlResultId: string,
    params: GetControlResultCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultComments>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlResultCommentsQueryKey(controlId,controlResultId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlResultComments>>> = ({ signal }) => getControlResultComments(controlId,controlResultId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId && controlResultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlResultComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlResultCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getControlResultComments>>>
export type GetControlResultCommentsQueryError = unknown


export function useGetControlResultComments<TData = Awaited<ReturnType<typeof getControlResultComments>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultComments>>,
          TError,
          Awaited<ReturnType<typeof getControlResultComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultComments<TData = Awaited<ReturnType<typeof getControlResultComments>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultComments>>,
          TError,
          Awaited<ReturnType<typeof getControlResultComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultComments<TData = Awaited<ReturnType<typeof getControlResultComments>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultComments>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get control result comments list
 */

export function useGetControlResultComments<TData = Awaited<ReturnType<typeof getControlResultComments>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    params: GetControlResultCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultComments>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlResultCommentsQueryOptions(controlId,controlResultId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create new control result comment
 */
export const createComment = (
    controlId: string,
    controlResultId: string,
    createControlResultCommentRequestDto: CreateControlResultCommentRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/${controlResultId}/comments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createControlResultCommentRequestDto, signal
    },
      options);
    }
  


export const getCreateCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComment>>, TError,{controlId: string;controlResultId: string;data: CreateControlResultCommentRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createComment>>, TError,{controlId: string;controlResultId: string;data: CreateControlResultCommentRequestDto}, TContext> => {

const mutationKey = ['createComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createComment>>, {controlId: string;controlResultId: string;data: CreateControlResultCommentRequestDto}> = (props) => {
          const {controlId,controlResultId,data} = props ?? {};

          return  createComment(controlId,controlResultId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCommentMutationResult = NonNullable<Awaited<ReturnType<typeof createComment>>>
    export type CreateCommentMutationBody = CreateControlResultCommentRequestDto
    export type CreateCommentMutationError = unknown

    /**
 * @summary Create new control result comment
 */
export const useCreateComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createComment>>, TError,{controlId: string;controlResultId: string;data: CreateControlResultCommentRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createComment>>,
        TError,
        {controlId: string;controlResultId: string;data: CreateControlResultCommentRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateCommentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Delete control result comment
 */
export const deleteComment = (
    controlId: string,
    controlResultId: string,
    commentId: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/${controlResultId}/comments/${commentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComment>>, TError,{controlId: string;controlResultId: string;commentId: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteComment>>, TError,{controlId: string;controlResultId: string;commentId: string}, TContext> => {

const mutationKey = ['deleteComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteComment>>, {controlId: string;controlResultId: string;commentId: string}> = (props) => {
          const {controlId,controlResultId,commentId} = props ?? {};

          return  deleteComment(controlId,controlResultId,commentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteComment>>>
    
    export type DeleteCommentMutationError = unknown

    /**
 * @summary Delete control result comment
 */
export const useDeleteComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteComment>>, TError,{controlId: string;controlResultId: string;commentId: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteComment>>,
        TError,
        {controlId: string;controlResultId: string;commentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCommentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Edit control result comment
 */
export const editComment = (
    controlId: string,
    controlResultId: string,
    commentId: string,
    editControlResultCommentRequestDto: EditControlResultCommentRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/controls/${controlId}/results/${controlResultId}/comments/${commentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: editControlResultCommentRequestDto
    },
      options);
    }
  


export const getEditCommentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editComment>>, TError,{controlId: string;controlResultId: string;commentId: string;data: EditControlResultCommentRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof editComment>>, TError,{controlId: string;controlResultId: string;commentId: string;data: EditControlResultCommentRequestDto}, TContext> => {

const mutationKey = ['editComment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editComment>>, {controlId: string;controlResultId: string;commentId: string;data: EditControlResultCommentRequestDto}> = (props) => {
          const {controlId,controlResultId,commentId,data} = props ?? {};

          return  editComment(controlId,controlResultId,commentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditCommentMutationResult = NonNullable<Awaited<ReturnType<typeof editComment>>>
    export type EditCommentMutationBody = EditControlResultCommentRequestDto
    export type EditCommentMutationError = unknown

    /**
 * @summary Edit control result comment
 */
export const useEditComment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editComment>>, TError,{controlId: string;controlResultId: string;commentId: string;data: EditControlResultCommentRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editComment>>,
        TError,
        {controlId: string;controlResultId: string;commentId: string;data: EditControlResultCommentRequestDto},
        TContext
      > => {

      const mutationOptions = getEditCommentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Generate signed upload URL for comment attachment
 */
export const generateCommentAttachmentUploadUrl = (
    controlId: string,
    controlResultId: string,
    generateCommentAttachmentUploadUrlRequestDto: GenerateCommentAttachmentUploadUrlRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GenerateCommentAttachmentUploadUrlResponseDto>(
      {url: `/controls/${controlId}/results/${controlResultId}/comments/upload-url`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateCommentAttachmentUploadUrlRequestDto, signal
    },
      options);
    }
  


export const getGenerateCommentAttachmentUploadUrlMutationOptions = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCommentAttachmentUploadUrl>>, TError,{controlId: string;controlResultId: string;data: GenerateCommentAttachmentUploadUrlRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCommentAttachmentUploadUrl>>, TError,{controlId: string;controlResultId: string;data: GenerateCommentAttachmentUploadUrlRequestDto}, TContext> => {

const mutationKey = ['generateCommentAttachmentUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCommentAttachmentUploadUrl>>, {controlId: string;controlResultId: string;data: GenerateCommentAttachmentUploadUrlRequestDto}> = (props) => {
          const {controlId,controlResultId,data} = props ?? {};

          return  generateCommentAttachmentUploadUrl(controlId,controlResultId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateCommentAttachmentUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof generateCommentAttachmentUploadUrl>>>
    export type GenerateCommentAttachmentUploadUrlMutationBody = GenerateCommentAttachmentUploadUrlRequestDto
    export type GenerateCommentAttachmentUploadUrlMutationError = null | null

    /**
 * @summary Generate signed upload URL for comment attachment
 */
export const useGenerateCommentAttachmentUploadUrl = <TError = null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCommentAttachmentUploadUrl>>, TError,{controlId: string;controlResultId: string;data: GenerateCommentAttachmentUploadUrlRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCommentAttachmentUploadUrl>>,
        TError,
        {controlId: string;controlResultId: string;data: GenerateCommentAttachmentUploadUrlRequestDto},
        TContext
      > => {

      const mutationOptions = getGenerateCommentAttachmentUploadUrlMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get signed URL for comment attachment
 */
export const getControlResultAttachmentUrl = (
    controlId: string,
    controlResultId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultAttachmentUrlResponseDto>(
      {url: `/controls/${controlId}/results/${controlResultId}/comments/attachment-url/${attachmentId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetControlResultAttachmentUrlQueryKey = (controlId?: string,
    controlResultId?: string,
    attachmentId?: string,) => {
    return [`/controls/${controlId}/results/${controlResultId}/comments/attachment-url/${attachmentId}`] as const;
    }

    
export const getGetControlResultAttachmentUrlQueryOptions = <TData = Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError = unknown>(controlId: string,
    controlResultId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlResultAttachmentUrlQueryKey(controlId,controlResultId,attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>> = ({ signal }) => getControlResultAttachmentUrl(controlId,controlResultId,attachmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId && controlResultId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlResultAttachmentUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>>
export type GetControlResultAttachmentUrlQueryError = unknown


export function useGetControlResultAttachmentUrl<TData = Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultAttachmentUrl>>,
          TError,
          Awaited<ReturnType<typeof getControlResultAttachmentUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultAttachmentUrl<TData = Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultAttachmentUrl>>,
          TError,
          Awaited<ReturnType<typeof getControlResultAttachmentUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultAttachmentUrl<TData = Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get signed URL for comment attachment
 */

export function useGetControlResultAttachmentUrl<TData = Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError = unknown>(
 controlId: string,
    controlResultId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachmentUrl>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlResultAttachmentUrlQueryOptions(controlId,controlResultId,attachmentId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get all attachments for a control result
 */
export const getControlResultAttachments = (
    controlId: string,
    controlResultId: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetControlResultAttachmentListResponseDto>(
      {url: `/controls/${controlId}/results/${controlResultId}/comments/attachments`, method: 'GET', signal
    },
      options);
    }
  

export const getGetControlResultAttachmentsQueryKey = (controlId?: string,
    controlResultId?: string,) => {
    return [`/controls/${controlId}/results/${controlResultId}/comments/attachments`] as const;
    }

    
export const getGetControlResultAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof getControlResultAttachments>>, TError = null>(controlId: string,
    controlResultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachments>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetControlResultAttachmentsQueryKey(controlId,controlResultId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControlResultAttachments>>> = ({ signal }) => getControlResultAttachments(controlId,controlResultId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(controlId && controlResultId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetControlResultAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getControlResultAttachments>>>
export type GetControlResultAttachmentsQueryError = null


export function useGetControlResultAttachments<TData = Awaited<ReturnType<typeof getControlResultAttachments>>, TError = null>(
 controlId: string,
    controlResultId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultAttachments>>,
          TError,
          Awaited<ReturnType<typeof getControlResultAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultAttachments<TData = Awaited<ReturnType<typeof getControlResultAttachments>>, TError = null>(
 controlId: string,
    controlResultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getControlResultAttachments>>,
          TError,
          Awaited<ReturnType<typeof getControlResultAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetControlResultAttachments<TData = Awaited<ReturnType<typeof getControlResultAttachments>>, TError = null>(
 controlId: string,
    controlResultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachments>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all attachments for a control result
 */

export function useGetControlResultAttachments<TData = Awaited<ReturnType<typeof getControlResultAttachments>>, TError = null>(
 controlId: string,
    controlResultId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getControlResultAttachments>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetControlResultAttachmentsQueryOptions(controlId,controlResultId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



